import AccessibilityCheckerContent from "../../../../src/pages/pricing/contact/sales/accessibilitychecker/accessibility_checker_content.md";
import { AccessbilityCheckerAPI } from "../../../../src/components/accessibilityCheckerForm";
import * as React from 'react';
export default {
  AccessibilityCheckerContent,
  AccessbilityCheckerAPI,
  React
};